import type { TFunction } from 'i18next';
import type { Milestone } from '../types';

export const isReplacedMilestone = (milestone: Pick<Milestone, 'stageReplacement'>) =>
  Boolean(milestone.stageReplacement);

/** Validity and completion are separate from the original payment history. */
export const isMilestoneSettledForClosure = (milestone: Milestone): boolean =>
  isReplacedMilestone(milestone) || (milestone.continuedBy?.settled ?? (
    (milestone.deliveryStatus === 'paid' ||
      (milestone.deliveryStatus === 'jointly_attested' && (milestone.payoutAmountAfterCredits ?? milestone.afterRotAmount) <= 0)) &&
    milestone.companyAttestation === 'approved' && milestone.personAttestation === 'approved'
  ));

export const replacementLabel = (milestone: Milestone, t: TFunction) =>
  t(milestone.stageReplacement?.kind === 'removed' ? 'milestoneHistory.removed' : 'milestoneHistory.replaced');
